// removed by extract-text-webpack-plugin
module.exports = {"commentsList":"style__commentsList___1Lxzp","commentsListTopOverlay":"style__commentsListTopOverlay___2jmPj","comment":"style__comment___2QtJz","commentLast":"style__commentLast___3xVzF","commentAvatarWrap":"style__commentAvatarWrap___-jcuO","commentAvatar":"style__commentAvatar___3-o3m","commentContent":"style__commentContent___2ig4X","commentAuthorName":"style__commentAuthorName___2HDqG","commentMessage":"style__commentMessage___32mdw","commentDate":"style__commentDate___1Hx-y","commentUnread":"style__commentUnread___2z19Y"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/comments-list/style.css
// module id = 1267
// module chunks = 0